const apiUrl = "https://centaur-api-dev.azure.chevron.com/api";

export const environment = {
  envName: "dev",
  production: false,
  authority:
    "https://login.microsoftonline.com/fd799da1-bfc1-4234-a91c-72b3a1cb9e26/v2.0",
  clientId: "72f3d60b-80b7-415e-b965-0d24beadad00",
  redirectUri: `${location.protocol}//${location.hostname}${location.port && ":" + location.port}/`,
  audience: "https://graph.microsoft.com",
  knownAuthorities: [
    "https://login.microsoftonline.com",
    "https://sts.windows.net",
  ],
  graphScopes: ["profile", "openid", "email", "User.Read", "User.Read.All"],
  apiScopes: ["api://72f3d60b-80b7-415e-b965-0d24beadad00/user_impersonation"],
  apiUrl,
};
